import React, { useState } from 'react';
import './Login.css';

const GROUP_REG_API = process.env.REACT_APP_GROUP_REGISTRATION_API_URL || 'http://localhost:8086';

const GroupLogin = ({ onLoginSuccess, onBack }) => {
  const [formData, setFormData] = useState({
    loginEmail: '',
    token: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) {
      setError('');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.loginEmail.trim() || !formData.token.trim()) {
      setError('Login email and token are required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(
        `${GROUP_REG_API}/group-registration/group-logins/validate-token?token=${encodeURIComponent(formData.token.trim())}`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        }
      );

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Failed to validate token');
      }

      const data = await response.json();

      if (!data.valid) {
        setError(data.message || 'Invalid or expired token');
        return;
      }

      const apiEmail = (data.loginEmail || '').trim().toLowerCase();
      const enteredEmail = formData.loginEmail.trim().toLowerCase();
      if (apiEmail && apiEmail !== enteredEmail) {
        setError('Login email does not match the provided token');
        return;
      }

      onLoginSuccess({
        loginEmail: formData.loginEmail.trim(),
        conferenceGroupId: data.conferenceGroupId,
        tokenExpiry: data.tokenExpiry
      });
    } catch (submitError) {
      console.error('Group login failed:', submitError);
      setError(submitError.message || 'Group login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Group Login</h2>
          <p>Enter corporate login email and token</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="loginEmail" className="form-label">
              Login Email <span className="required">*</span>
            </label>
            <input
              type="email"
              id="loginEmail"
              name="loginEmail"
              value={formData.loginEmail}
              onChange={handleInputChange}
              className={`form-control ${error ? 'error' : ''}`}
              placeholder="Enter your corporate login email"
              autoComplete="email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="token" className="form-label">
              Login Token <span className="required">*</span>
            </label>
            <input
              type="password"
              id="token"
              name="token"
              value={formData.token}
              onChange={handleInputChange}
              className={`form-control ${error ? 'error' : ''}`}
              placeholder="Enter token"
              autoComplete="current-password"
              required
            />
          </div>

          {error && <span className="error-message">{error}</span>}

          <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner"></span>
                Validating...
              </>
            ) : (
              'Continue'
            )}
          </button>
        </form>

        <div className="login-footer">
          <button type="button" className="btn btn-link" onClick={onBack}>
            Back to registration type selection
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupLogin;
